// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"678be0d9","66":"9f229e5c","73":"d12d0332","96":"7a81460a","129":"496469b2","168":"56fe6968","171":"15686da5","183":"8daf078c","252":"68925021","352":"fdf96e2a","480":"d3517055","507":"8ef3319f","546":"7d95f098","656":"bfc5e500"}[chunkId] + ".chunk.js";
};